import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { DropdownList, Icons } from '@/js/libs/ui/src/V2';

import { TableDropdownList } from 'src/components/TableDropdownList';
import type { ColumnProps } from '../../types';

export const UnassignedActionsCell: React.FC<ColumnProps> = React.memo(function UnassignedActionsCell({
  item,
  assignModalState,
  archiveModalState,
}) {
  const [t] = useTranslation(['backend', 'common', 'adTags']);

  const handleAssign = useCallbackRef(() => {
    if (item.id) {
      assignModalState?.open([item.id]);
    }
  });

  const handleArchive = useCallbackRef(() => {
    if (item.id) {
      archiveModalState?.open([item.id]);
    }
  });

  return (
    <TableDropdownList>
      <DropdownList.DropdownItem icon={<Icons.PersonAdd />} onClick={handleAssign} dataTestId='add-assignee-button'>
        {t('common:ASSIGN')}
      </DropdownList.DropdownItem>
      <DropdownList.DropdownItem icon={<Icons.Archived />} onClick={handleArchive} dataTestId='archive-button'>
        {t('adTags:ARCHIVE_TAG')}
      </DropdownList.DropdownItem>
    </TableDropdownList>
  );
});
